import React from 'react';


import {
    TopicDiv,
    NewTopic,
    NewButton,
    ActiveTopic,
    NewTopicDesc,
    Desc,
    Wrapper,
    Heading,
    ActiveTopicDiv,
    NewTopicSpan,
} from '../TopicBuilder/MainContent/HomePage/HomePage.styled';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const HomePage = () => {
    
      const navigate = useNavigate();
    
      const handleTopicClick = (job_id) => {
        navigate('/enterprise/job_'+job_id);
      };

    const { jobsList } = useSelector((state) => state.enterprise);
    return (
        <Wrapper>
            {/* <TopicDiv>Topic Listening</TopicDiv>
            <Desc>Discover brand insights, craft custom reports</Desc> */}
            <NewTopic>
                <NewTopicSpan>Manage and Upload Enterprise Data</NewTopicSpan>
                <NewTopicDesc>
                    Integrate your custom enterprise data to power richer analytics with real-time insights. You can upload new datasets or update existing ones for past reporting periods.
                </NewTopicDesc>
            </NewTopic>
            <ActiveTopic>
                <Heading>Review Past Uploads</Heading>
                <div className='topicWrapper'>
                    {
                        jobsList.map((el) => (
                            <ActiveTopicDiv
                                key={el.job_id}
                                onClick={() => handleTopicClick(el.job_id)}
                            ><p>
                                    {el.title}
                                </p>
                            </ActiveTopicDiv>
                        ))
                    }
                </div>
            </ActiveTopic>
        </Wrapper>
    );
};


export default HomePage;